module.exports = __webpack_public_path__ + "img/cdq2b16-30.prt.e6d2d44c.jpg";